import CustomerTableForConsolidationRevenue from './CustomerTableForConsolidateRevenue';
import { useGetConsolidateRevenue } from 'hooks/uesGetConsolidateRevenue';
import { transformDataToTable } from './utils';
import { useMemo } from 'react';
import { GetConsolidateRevenueData, TransformedRevenueData } from 'services/api/type/report.type';
import { useTranslation } from 'react-i18next';

interface NationalityConsolidateRevenueProps {
  type_of_response: string;
  filterOptions: any;
  isEnable: boolean;
  setDataSource: (data: any[]) => void;
}

export default function NationalityTab({
  type_of_response,
  filterOptions,
  isEnable,
  setDataSource
}: NationalityConsolidateRevenueProps) {
  const { t } = useTranslation();
  const { data: consolidateRevenue, isLoading } = useGetConsolidateRevenue(
    {
      ...filterOptions,
      type_of_response: type_of_response
    },
    isEnable
  );

  const dataSource = useMemo(() => {
    if (consolidateRevenue) {
      return transformDataToTable(
        consolidateRevenue as unknown as GetConsolidateRevenueData,
        t
      ) as unknown as TransformedRevenueData[];
    }
    return [];
  }, [consolidateRevenue, t]);

  setDataSource(dataSource);

  return (
    <CustomerTableForConsolidationRevenue
      loading={isLoading}
      dataSource={dataSource}
      title={t('common.customer.nationality')}
    />
  );
}
